<template>
	<div class="message-header">
		<slot name="name">
			<UserName
				v-if="user"
				:user="user"
				class="message-name pointer"
				@click="$emit('click-name')"
			/>
		</slot>
		<MessageTime :date="date" />
		<LocationDotIcon
			v-if="hasLocation"
			type="solid"
			class="location-indicator"
		/>
		<div class="pinned-banner" v-if="isPinned">
			<ThumbtackIcon class="pin-icon" type="solid" />
			{{ pinnedLabel }}
		</div>
		<CopyToClipboard
			class="message-header-id"
			v-if="showMessageId"
			:value="messageId"
		>
			<span v-text="messageId" />
		</CopyToClipboard>
	</div>
</template>

<script>
import { UserName, CopyToClipboard } from '../common'
import MessageTime from './MessageTime'
import { LocationDotIcon, ThumbtackIcon } from '@/icons'

export default {
	name: 'MessageHeader',

	components: {
		UserName,
		MessageTime,
		LocationDotIcon,
		ThumbtackIcon,
		CopyToClipboard,
	},

	props: {
		user: { type: Object, default: null },
		date: { type: String, default: null },
		hasLocation: { type: Boolean, default: false },
		isPinned: { type: Boolean, default: false },
		showMessageId: { type: Boolean, default: false },
		messageId: { type: [String, Number], default: null },
		pinnedLabel: { type: String, default: '' },
	},

	emits: ['click-name'],
}
</script>

<style lang="scss" scoped>
@import 'src/sass/variables';

.message-header {
	display: flex;
	align-items: center;
}

.message-name {
	font-family: Avenir-Heavy;
	font-size: 15px;
	color: var(--neutral-800);
	display: inline-block;
	&:hover {
		text-decoration: underline;
	}
}

.location-indicator {
	font-size: 10px;
	margin-bottom: 1px;
	color: var(--neutral-400);
}

.pinned-banner {
	background-color: var(--blue-100);
	border-radius: 40px;
	font-size: 12px;
	color: var(--blue-400);
	font-family: Avenir-Heavy;
	padding: 0 8px;
	height: 20px;
	display: flex;
	align-items: center;
	justify-content: center;
	.pin-icon {
		margin-right: 3px;
	}
}

.message-header-id {
	font-size: 12px;
	color: var(--neutral-400);
}
</style>
